<template>
    <div class="content">

        <!-- <v-card class="ma-3 px-3 py-3" tile> -->
            <v-card class="mb-3 py-3 px-6" color="white" tile>
                <v-row>
                <v-col cols="12" md="9" class="d-flex">
                    <v-text-field :hide-details="true" v-model="filter.q" :label="$t('common.filter.searchBy', {name: '...'})"></v-text-field>
                    <v-btn text fab>
                        <v-icon size="32">mdi-magnify</v-icon>
                    </v-btn>
                </v-col>
                <v-col class="d-flex">

                    <!-- <v-select :hide-details="true"  v-model="filter.pp" :items="[5,10,25,50]" label="Itens por página"></v-select> -->
                    <!-- <v-select :hide-details="true"  v-model="filter.pp" :items="[5,10,25,50]" label="Itens por página"></v-select> -->
                    <v-select  :menu-props="{ maxHeight: '400' }" :hide-details="true" style="max-width: 180px" 
                        v-model="filter.columns" multiple :items="columns" :label="$t('common.filter.columns')" item-value="index" item-text="name"
                        > <!--@change="changeHeader"-->
                        <template v-slot:selection="{ item, index }">

                            <span :alt="item" v-if="index === 0" class="text-p">
                                {{ $tc('common.filter.selected', filter.columns.length,  {count: filter.columns.length}) }} 
                            </span>
                        </template>
                    </v-select>
                    <v-menu offset-y :close-on-content-click="false" ref="menu" v-model="menu"
                        :return-value.sync="filter.dates" transition="scale-transition">
                        <template v-slot:activator="{ on, attrs }">

                            <v-text-field v-model="dateRangeText" v-bind="attrs" v-on="on" :label="$t('common.filter.dateRange')" :hide-details="true"
                                append-icon="mdi-calendar" readonly></v-text-field>
                        </template>

                        <v-date-picker no-title scrollable v-model="filter.dates" range is-double-paned
                        :locale="$i18n.locale"
                        is-inline>
                            <v-spacer></v-spacer>
                            <v-btn text color="red" @click="menu = false">
                                {{ $t('common.cancel') }}
                            </v-btn>
                            <v-btn dark color="primary" @click="$refs.menu.save(filter.dates)">
                                {{ $t('common.ok') }}
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>


        </v-card>
        <v-card class="ma-3">
            <GanttMode :items="documents" :query-text="filter.q" :dates="filter.dates" :headers="filter.columns" :types="columns"></GanttMode>
        </v-card>
    </div>
</template>
<script>
import GanttMode from '@/interface/GanttMode.vue';
import moment from 'moment'
export default {
    components: { GanttMode },

    data: () => ({
        menu: false,
      
        filter: {
            q: "",
            pp: 10,
            dates: [moment().subtract(5,'days').format('YYYY-MM-DD'), moment().add(15,'days').format('YYYY-MM-DD')],
            columns: [0,1]
        },
        columns: [
            { index: 0, name: "title", fixed: false, type: 'text' },
            { index: 1, name: "customer", fixed: false, type: 'text' },
            { index: 2, name: "price", fixed: false, type: 'currency' },
           
        ],
       
        headers: [],
        documents: [
            { id: 3, info: { title: "Campanha sugerida",  customer: 'Bluu Design', "price": 192.3}, color: '#dce0ef', start: '2022-11-21', end: '2022-12-09', status: 'Aguardando veiculação' },
            { id: 11, info: {title: "Natal 2022", customer: 'Alcantara machado', price: 43403.30}, color: '#ffebee', start: '2022-11-10', end: '2022-11-17', status: 'Aguardando aprovação de PI' },
            { id: 12,  info: {title: "Black Friday Agro", customer: 'Alcantara machado', price: 2030}, color: '#dce0ef', start: '2022-11-12', end: '2022-12-01', status: 'Em veiculação' },
            { id: 17,  info: {title: "Black Friday Agro",customer: 'The Media Trade', price: 2000}, color: '#bfd0ff', start: '2022-12-01', end: '2022-12-14', status: 'Aguardando veiculação' },
            { id: 22,  info: {title: "Campanha sugerida 3",customer: 'Bluu Design', price:636.44}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22,  info: {title: "Nova campanha",customer: 'Bluu Design', price: 5040}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22,  info: {title: "Calendário Escolar",customer: 'Bluu Design',price: 540.3}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22, info: {title: "Campanha sugerida",customer: 'Bluu Design', price: 299.9}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22,  info: {title: "Campanha sugerida", customer: 'Bluu Design', price: 2003.44}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22,  info: {title: "Campanha sugerida", customer: 'Bluu Design', price: 400.90}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' },
            { id: 22, info: {title: "Campanha sugerida", customer: 'Bluu Design', price: 4403}, color: '#bfd0ff', start: '2022-12-15', end: '2023-01-21', status: 'Aguardando veiculação' }
        ],
    }),
    computed: {
        dateRangeText() {
            let start = moment(this.filter.dates[0], 'YYYY-MM-DD').locale(this.$i18n.locale).format('L')
            let end = moment(this.filter.dates[1], 'YYYY-MM-DD').locale(this.$i18n.locale).format('L')
            if(start != end && this.filter.dates.length > 1)
                return `${start} ~ ${end}`
            return start
        }
    },
    methods: {
        // changeHeader() {
        //     const result = []
        //     this.columns.forEach((item, index) => {
        //         if (this.filter.columns.includes(index))
        //             result.push(item.index)
        //     })
        // }
    },
    created() {
        this.headers = this.allHeaders
    }
}
</script>
<style lang="scss">
.--chart {
    flex: 0 0 70%;

    .text-caption {
        opacity: 0;
        padding-top: 5px;
        transition: .15s all;
    }

    svg {
        opacity: 1;
        transition: .15s all;
    }

    &:hover {
        .text-caption {
            opacity: 1;
            padding-top: 0;
            padding-bottom: 5px;
        }

        svg {
            opacity: 0.25;
            transition: .15s all;
        }
    }
}
</style>